import bem from 'utils/bem';

export const block = bem('non-ideal-state');
